// src/components/AlbumPageTemplates/Grid.jsx
// REPLACE the entire file with this code

import React from 'react';
import styled from 'styled-components';
import PrintSafeImage from '../PrintSafeImage'; // <-- ADDED

const GridContainer = styled.div`
  width: 100%;
  height: 100%;
  padding: 24px;
  display: grid;
  background-color: #ffffff;
  box-sizing: border-box;
  gap: 24px; 
`;

const PhotoCell = styled.div`
  background-color: #f3f4f6;
  border-radius: 4px;
  overflow: hidden;
  box-shadow: 0 4px 15px rgba(0, 0, 0, 0.08);
  border: 4px solid white;
  position: relative; /* <-- ADD THIS ONE LINE BACK */
  
  
  /* This ensures the canvas/img fills the cell */
  & > * {
    width: 100%;
    height: 100%;
  }
`;

// This helper is no longer needed, but we leave it
// in case other parts of your code use it.
const Photo = styled.img`
  width: 100%;
  height: 100%;
  object-fit: cover;
  display: block;
`;

function getAreaNames(areasString = '') {
  const names = areasString
    .replace(/'/g, '')
    .split(/\s+/)
    .filter(Boolean);
  return [...new Set(names)];
}

// ADDED isPrinting to props
export default function Grid({ items = [], cols = 2, rows = 2, areas = '', isPrinting }) {
  
  const gridStyle = {};
  let areaNames = [];

  if (areas) {
    gridStyle.gridTemplateAreas = areas;
    gridStyle.gridTemplateColumns = `repeat(${cols}, 1fr)`;
    gridStyle.gridTemplateRows = `repeat(${rows}, 1fr)`;
    areaNames = getAreaNames(areas);
  } else {
    gridStyle.gridTemplateColumns = `repeat(${cols}, 1fr)`;
    gridStyle.gridTemplateRows = `repeat(${rows}, 1fr)`;
  }

  const cellCount = areas ? areaNames.length : cols * rows;
  const cells = Array.from({ length: cellCount }).map((_, i) => items[i] || null);

  
  return (
    <GridContainer style={gridStyle}>
      {cells.map((item, i) => {
        const position = item?.position || { x: 50, y: 50, scale: 100 };
        
        // This object combines the styled <Photo> styles
        // with the inline photoStyle
        // This object combines the styled <Photo> styles
// with the inline photoStyle
const fullPhotoStyle = isPrinting ? {
  // PDF-safe styles for PrintSafeImage's canvas
  position: 'absolute',
  width: '100%',
  height: 'auto',
  minWidth: '100%',
  minHeight: '100%',
  top: '50%',
  left: '50%',
  transform: `translate(-50%, -50%) scale(${position.scale / 100}) translateX(${position.x - 50}%) translateY(${position.y - 50}%)`,
} : {
  // LIVE PREVIEW styles - reverted to object-fit
  width: '100%',
  height: '100%',
  objectFit: 'cover',
  display: 'block',
  objectPosition: `${position.x}% ${position.y}%`,
  transform: `scale(${position.scale / 100})`,
  transformOrigin: `${position.x}% ${position.y}%`,
};

        return (
          <PhotoCell 
            key={i} 
            style={areas ? { gridArea: areaNames[i] } : {}}
          >
            {item?.url && (
              // REPLACED <Photo> with <PrintSafeImage>
              <PrintSafeImage
                src={item.url} 
                alt="" 
                style={fullPhotoStyle}
                position={position}
                isPrinting={isPrinting}
              />
            )}
          </PhotoCell>
        );
      })}
    </GridContainer>
  );
}